import { type FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Image } from '@chakra-ui/react';
import { Button, View, YStack } from '@shinetools/sunshine-universal';

import fadedFlowerImg from 'assets/brand/faded-flower@2x.png';
import SunshineModal from 'components/_core/SunshineModal';

export type AsyncChallengeProps = {
  isOpen: boolean;
  onClose: (arg0: boolean) => void;
};

const ApprovedChallenge: FC<AsyncChallengeProps> = ({ isOpen, onClose }) => {
  return (
    <SunshineModal isOpen={isOpen} onClose={() => onClose(true)}>
      <YStack alignItems="flex-end" flexDirection="column">
        <View padding="$space.16">
          <Button
            hugContent={true}
            icon="cross"
            onPress={() => onClose(true)}
            variant="secondary"
          >
            <FormattedMessage id="authentication.close" />
          </Button>
        </View>
      </YStack>
      <SunshineModal.Body padding={0}>
        <View backgroundColor="$grey.200" height={208} padding={0}>
          <Image marginX="auto" src={fadedFlowerImg} width="180px" />
        </View>

        <View gap="$space.16" padding="$space.32">
          <SunshineModal.Title>
            <FormattedMessage id="authentication.challenge.approved.description.origin_device" />
          </SunshineModal.Title>
        </View>
      </SunshineModal.Body>
    </SunshineModal>
  );
};

export default ApprovedChallenge;
